import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { Querystring } from 'utils/url';

import type { Action } from 'types';

const LOADING = 'influencerCampaignHistory/LOADING';
const LOADED = 'influencerCampaignHistory/LOADED';
const RESET = 'influencerCampaignHistory/RESET';

const initialState = {
  isLoading: false,
  list: []
};

function setLoadingStatus(status: boolean): Action {
  return {
    type: LOADING,
    payload: {
      status
    }
  };
}

export function resetInfluencerCampaignHistory(): Action {
  return {
    type: RESET
  };
}

function InfluencerCampaignHistoryLoaded(data): Action {
  return {
    type: LOADED,
    payload: {
      data
    }
  };
}

export function fetchInfluencerCampaignHistory(organizationId: number, creatorId: number, options: any) {
  const params = {
    filter_by: options.filter,
    include_metrics: options.includeMetrics
  };

  const queryString = Querystring.objectToString(params);
  const url = `${API.END_POINTS.INFLUENCERS.getInfluencerCampaignHistory(organizationId, creatorId)}?${queryString}`;

  return async (dispatch) => {
    dispatch(setLoadingStatus(true));

    try {
      const response = await get(url);
      dispatch(InfluencerCampaignHistoryLoaded(response.data));
    } catch (error) {
      dispatch(setLoadingStatus(false));
      throw error;
    }
  };
}

export default createReducer<any, any>('influencerCampaignHistory', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [LOADED]: (state, { data }) => ({
    ...state,
    list: data.historicalData,
    isLoading: false
  })
});
